// Design tokens for the Cost Estimation application.
// Kept intentionally lightweight (plain JS objects, no CSS framework) —
// consistent with the "lightweight implementation" requirement.
//
// Values aligned to CostSpace's designTokens.js so Estimation reads as
// part of the same product family. Variable names are unchanged from
// the original file -- only the hex/rgba values were updated where
// they differed from the CostSpace reference.
export const colors = {
  primary: '#1B3A6B',
  primaryHover: '#152e57',
  accentGreen: '#1A7A4A',
  bg: '#F3F4F6',
  surface: '#FFFFFF',
  border: '#E5E7EB',
  borderStrong: '#D1D5DB',
  textPrimary: '#0F1017',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
  danger: '#DC2626',
  dangerBg: '#FEF2F2',
  warningBg: '#FEF3C7',
  warningText: '#D97706',
  successBg: '#F0FDF4',
  successText: '#1A7A4A',
}

export const statusStyles = {
  draft: { bg: '#F3F4F6', text: '#4B5563' },
  under_review: { bg: '#FFFBEB', text: '#92400E' },
  manager_approved: { bg: '#EFF6FF', text: '#1D4ED8' },
  committee_approved: { bg: '#EEF2FF', text: '#4338CA' },
  frozen: { bg: '#ECFEFF', text: '#0E7490' },
  rejected: { bg: '#FEF2F2', text: '#B91C1C' },
  archived: { bg: '#F9FAFB', text: '#9CA3AF' },
  active: { bg: '#F0FDF4', text: '#15803D' },
}

export const font = {
  family:
    "system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  mono: "'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace",
}

export const numberFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  if (Number.isNaN(n)) return '—'
  return numberFormatter.format(n)
}

export function formatPercent(value) {
  if (value === null || value === undefined || value === '') return '—'
  return `${Number(value).toFixed(1)}%`
}
